import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { node } from "prop-types";
import FeedbackDialog from "./FeedbackDialog";

const FeedbackContext = createContext(null);

/**
 * Holds the single in-app feedback dialog and exposes openFeedback().
 * Mounted once (in Layout) so any menu can trigger it without each owning the
 * dialog — this keeps the dialog above transient menus/sheets and lets a menu
 * close itself while the dialog stays open.
 */
export const FeedbackProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openFeedback = useCallback(() => setOpen(true), []);
  const closeFeedback = useCallback(() => setOpen(false), []);

  const value = useMemo(() => ({ openFeedback }), [openFeedback]);

  return (
    <FeedbackContext.Provider value={value}>
      {children}
      <FeedbackDialog open={open} onClose={closeFeedback} />
    </FeedbackContext.Provider>
  );
};

FeedbackProvider.propTypes = { children: node };

export const useFeedback = () => {
  const ctx = useContext(FeedbackContext);
  if (!ctx) throw new Error("useFeedback must be used within a FeedbackProvider");
  return ctx;
};
